import type { LeagueSummary } from '@/features/league/types'

export type CompetitionOption = {
  id:   string
  name: string
}

export function competitionOptions(leagues: LeagueSummary[]): CompetitionOption[] {
  const seen = new Set<string>()
  const options: CompetitionOption[] = []
  for (const league of leagues) {
    if (!seen.has(league.competitionId)) {
      seen.add(league.competitionId)
      options.push({ id: league.competitionId, name: league.competitionName })
    }
  }
  return options
}
